// Translations
import form from '../sections/form/translations/de'

// Translation: Register > Landing (German)
export default Object.freeze({
	sections: { form }
})
